
import DateFiltersProvider from "../../../components/shared/filters/DateFilters/context";
import Component from "../Component";
import SessionFiltersGate from "../../../components/shared/filters/SessionFiltersGate";
import { SCHEDULE_TRANSIENT_PARAMS } from "../Component/constants/scheduleTypes";
import { MenuProvider } from "../Component/context/Menu";
import { ScheduleProvider } from "../Component/context/Schedule";
import { ScrollProvider } from "../Component/context/Scroll";

function Team() {
    return (
        <div className="tw-h-full tw-w-full tw-bg-white tw-rounded-lg">
            <SessionFiltersGate storageKey="traxxion-schedule:team" excludeParams={SCHEDULE_TRANSIENT_PARAMS}>
                <DateFiltersProvider mode="day">
                    <ScheduleProvider type="team">
                        <ScrollProvider>
                            <MenuProvider>
                                <Component />
                            </MenuProvider>
                        </ScrollProvider>
                    </ScheduleProvider>
                </DateFiltersProvider>
            </SessionFiltersGate>
        </div>
    );
}

export default Team;
